module.exports = __webpack_public_path__ + "images/bannerFR-772b36437a321b11648e44d413c676ec.jpg";